import React from "react";
import {Col, Row} from "react-bootstrap";

const NoRegistrationsAlert = (props) => {
   return <Row>
      <Col xs={{span: 10, offset: 1}}>
         <div className="alert alert-info mt-4" role="alert">
            {props.text}
         </div>
      </Col>
   </Row>
}

export default NoRegistrationsAlert;